const REGION_MAP = {
  'fluxerp.co.uk': {
    region: 'UK',
    currency: 'GBP',
    currencySymbol: '£',
    phonePrefix: '+44',
    locale: 'en-GB',
    contact: {
      addressLine1: '28 The Close',
      addressLine2: 'Iver SL0 OHE, United Kingdom',
      phone: '+44 7723 481288',
      whatsapp: '447538431506',
      email: 'info@fluxerp.co.uk',
      hours: 'Mon-Fri, 9am-5pm GMT'
    },
    legalBlurb: 'Registered in England No. 15494063. Address 28 The Close, Iver SL0 OHE United Kingdom. FluxERP is a registered trademark of FLUX IT STUDIO LTD. Terms and conditions, features, support, pricing, and service options subject to change without notice.'
  },
  'www.fluxerp.co.uk': {
    region: 'UK',
    currency: 'GBP',
    currencySymbol: '£',
    phonePrefix: '+44',
    locale: 'en-GB',
    contact: {
      addressLine1: '28 The Close',
      addressLine2: 'Iver SL0 OHE, United Kingdom',
      phone: '+44 7723 481288',
      whatsapp: '447538431506',
      email: 'info@fluxerp.co.uk',
      hours: 'Mon-Fri, 9am-5pm GMT'
    },
    legalBlurb: 'Registered in England No. 15494063. Address 28 The Close, Iver SL0 OHE United Kingdom. FluxERP is a registered trademark of FLUX IT STUDIO LTD. Terms and conditions, features, support, pricing, and service options subject to change without notice.'
  },
  'fluxerp.pk': {
    region: 'PK',
    currency: 'PKR',
    currencySymbol: '₨',
    phonePrefix: '+92',
    locale: 'en-PK',
    contact: {
      addressLine1: 'Ghalib Market, Gulberg-III',
      addressLine2: 'Lahore, Pakistan',
      phone: '+92 333 4044405',
      whatsapp: '923334044405',
      email: 'info@fluxerp.pk',
      hours: 'Mon-Sat, 9am-7pm PKT'
    },
    legalBlurb: 'FluxERP is a trademark of FLUX IT STUDIO LTD, United Kingdom. In Pakistan, services are operated by FLUX IT STUDIO (PRIVATE) LIMITED, a company registered with the Securities and Exchange Commission of Pakistan (SECP). Terms, features, pricing, and support services are subject to change without notice.'
  },
  'www.fluxerp.pk': {
    region: 'PK',
    currency: 'PKR',
    currencySymbol: '₨',
    phonePrefix: '+92',
    locale: 'en-PK',
    contact: {
      addressLine1: 'Ghalib Market, Gulberg-III',
      addressLine2: 'Lahore, Pakistan',
      phone: '+92 333 4044405',
      whatsapp: '923334044405',
      email: 'info@fluxerp.pk',
      hours: 'Mon-Sat, 9am- 7pm PKT'
    },
    legalBlurb: 'FluxERP is a trademark of FLUX IT STUDIO LTD, United Kingdom. In Pakistan, services are operated by FLUX IT STUDIO (PRIVATE) LIMITED, a company registered with the Securities and Exchange Commission of Pakistan (SECP). Terms, features, pricing, and support services are subject to change without notice.'
  },
  'fluxerp.qa': {
    region: 'QA',
    currency: 'QAR',
    currencySymbol: '﷼',
    phonePrefix: '+974',
    locale: 'ar-QA',
    defaultLanguage: 'ar',
    contact: {
      addressLine1: 'Al Sarh Street, Umm Ghuwailina',
      addressLine2: 'Doha, Qatar',
      phone: '+974 71234357',
      whatsapp: '97471234357',
      email: 'info@fluxerp.qa',
      hours: 'Sun-Thu, 9am-6pm AST'
    },
    legalBlurb: 'FluxERP is a trademark of FLUX IT STUDIO LTD, United Kingdom. In Qatar, services are operated by FLUX TECHNOLOGIES LLC. a company registered with QFC. Terms, pricing, support, and service features are subject to change without notice.'
  },

  'www.fluxerp.qa': {
    region: 'QA',
    currency: 'QAR',
    currencySymbol: '﷼',
    phonePrefix: '+974',
    locale: 'ar-QA',
    defaultLanguage: 'ar',
    contact: {
      addressLine1: 'Al Sarh Street, Umm Ghuwailina',
      addressLine2: 'Doha, Qatar',
      phone: '+974 71234357',
      whatsapp: '97471234357',
      email: 'info@fluxerp.qa',
      hours: 'Sun-Thu, 9am-6pm AST'
    },
    legalBlurb: 'FluxERP is a trademark of FLUX IT STUDIO LTD, United Kingdom. In Qatar, services are operated by FLUX TECHNOLOGIES LLC. a company registered with QFC. Terms, pricing, support, and service features are subject to change without notice.'
  }
};

const DEFAULT_REGION = REGION_MAP['fluxerp.co.uk'];

export const getRegionConfig = () => {
  const hostname = window.location.hostname;
  return REGION_MAP[hostname] || DEFAULT_REGION;
};

export default REGION_MAP;
